<template>
	<div class="compared-chart">
		<div class="chart-container">
			<canvas id="neighboor-chart"></canvas>
		</div>
	</div>
</template>

<script>
import Chart from "chart.js";

export default {
	name: "comps-in-area",
	props: {
		comparedChart: Array,
	},
	computed: {
		comparedTable() {
			return this.$store.getters.getAllPropertyData.comparedTable;
		},
	},
	methods: {
		createChart(chartId, chartData) {
			const ctx = document.getElementById(chartId);
			const myChart = new Chart(ctx, {
				type: chartData.type,
				data: chartData.data,
				options: chartData.options,
			});
		},
		labels() {
			let chartLabel = [];
			this.comparedChart.forEach((element) => {
				chartLabel.push(element.location);
			});
			return chartLabel.slice(0, 4);
		},
		values() {
			let chartValues = [];
			this.comparedChart.forEach((element) => {
				chartValues.push(element.buildingSqFt);
			});
			return chartValues.slice(0, 4);
		},
	},
	data() {
		return {
			neighboorChartData: {
				type: "bar",
				data: {
					labels: this.labels(),
					datasets: [
						{
							// one line graph
							label: "Assessment/SqFt",
							data: this.values(),
							backgroundColor: [
								"#E892A2",
								"rgba(97, 0, 255, 0.25)",
								"rgba(97, 0, 255, 0.25)",
								"rgba(97, 0, 255, 0.25)",
								"rgba(97, 0, 255, 0.25)",
							],
							borderColor: ["#6100FF", "#6100FF", "#6100FF", "#6100FF", "#6100FF"],
							borderWidth: 0,
						},
					],
				},
				options: {
					responsive: true,
					lineTension: 1,
					scales: {
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 10,
								},
								position: "right",
							},
						],
					},
				},
			},
		};
	},
	mounted() {
		this.createChart("neighboor-chart", this.neighboorChartData);
	},
};
</script>

<style scoped lang="scss">
.compared-chart {
	margin-top: 35px;
	display: flex;
	justify-content: center;
	.table-title {
		font-weight: 600;
		font-size: 22px;
		margin: 18px 0;
		padding-left: 35px;
	}
	.table-container {
		border-collapse: collapse;
		// width: 100%;
		// table-layout: fixed;
		width: 775px;
		th {
			padding: 12px 0;
			text-align: left;
			background-color: var(--primary);
			color: #f6f4f3;
			font-weight: 500;
			height: 100px;
		}
		tr {
			border-radius: 8px;
			height: 75px;
		}
		td,
		th {
			// border: 1px solid #ddd;
			padding: 8px;
		}
		.header4 {
			color: #595959;
		}
		tr:nth-child(2n + 3) {
			background: rgba(97, 0, 255, 0.05);
		}
	}
	.chart-container {
		width: 577px;
		height: 344px;
	}
}
@media screen and (max-width: 414px) {
	.compared-chart {
		padding: 3rem 1rem;
		.chart-container {
			display: none;
		}
	}
}
</style>
